var _rect, _path, _g, _use, _use2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBih(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 800,
    height: 400,
    viewBox: "0 0 16 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 8,
    fill: "#002395"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4.24,0h8v8z",
    fill: "#fecb00"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.353283,0.5248529 2.8,-0.85 3.246717,0.524853 2.077197,-0.324853H3.522803z",
    fill: "#fff",
    id: "s"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    x: 1,
    y: 1
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    x: 2,
    y: 2
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    x: 3,
    y: 3
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    x: 6,
    y: 6
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBih);
export default __webpack_public_path__ + "static/media/bih.aedb4fa86fa264a5eda3ce6f58bece66.svg";
export { ForwardRef as ReactComponent };